import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import './AutosuggestInput.scss';
import { analyticsTrack } from '../../../analyticsUtils';
var TRACKING_EVENT_TIME = 1000;
var renderSuggestion = function renderSuggestion(suggestion) {
  return /*#__PURE__*/React.createElement("span", null, suggestion);
};
var getSuggestionValue = function getSuggestionValue(suggestion) {
  return suggestion;
};
var AutosuggestInput = /*#__PURE__*/function (_Component) {
  function AutosuggestInput(props) {
    var _this;
    _classCallCheck(this, AutosuggestInput);
    _this = _callSuper(this, AutosuggestInput, [props]);
    _this.state = {
      value: props.value,
      suggestions: []
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onSuggestionsFetchRequested = _this.onSuggestionsFetchRequested.bind(_this);
    _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
    _this.getSuggestions = _this.getSuggestions.bind(_this);
    _this.trackEvent = debounce(_this.constructor.trackEvent.bind(_this), TRACKING_EVENT_TIME);
    return _this;
  }
  _inherits(AutosuggestInput, _Component);
  return _createClass(AutosuggestInput, [{
    key: "onSuggestionsFetchRequested",
    value: function onSuggestionsFetchRequested(_ref) {
      var value = _ref.value;
      this.setState({
        suggestions: this.getSuggestions(value)
      });
    }
  }, {
    key: "onSuggestionsClearRequested",
    value: function onSuggestionsClearRequested() {
      this.setState({
        suggestions: []
      });
    }
  }, {
    key: "onChange",
    value: function onChange(event, _ref2) {
      var newValue = _ref2.newValue;
      var handleChange = this.props.handleChange;
      handleChange(newValue);
      this.setState({
        value: newValue
      });
      this.trackEvent();
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions(value) {
      var allSuggestions = this.props.allSuggestions;
      var inputValue = value.trim().toLowerCase();
      var inputLength = inputValue.length;
      return inputLength === 0 ? [] : allSuggestions.filter(function (sug) {
        return sug.toLowerCase().indexOf(inputValue) !== -1;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        suggestions = _this$state.suggestions;
      var _this$props = this.props,
        classNames = _this$props.classNames,
        location = _this$props.location;
      var inputProps = {
        placeholder: 'Type a role...',
        value: value,
        id: location ? "".concat(location, "-role") : 'role',
        onChange: this.onChange,
        className: classNames
      };
      return /*#__PURE__*/React.createElement(Autosuggest, {
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: getSuggestionValue,
        renderSuggestion: renderSuggestion,
        inputProps: inputProps
      });
    }
  }], [{
    key: "trackEvent",
    value: function trackEvent() {
      analyticsTrack('User typed a role', {
        location: 'Search Index'
      });
    }
  }]);
}(Component);
AutosuggestInput.propTypes = {
  allSuggestions: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func.isRequired,
  classNames: PropTypes.string,
  value: PropTypes.string,
  location: PropTypes.string
};
AutosuggestInput.defaultProps = {
  allSuggestions: [],
  classNames: '',
  value: '',
  location: ''
};
export default AutosuggestInput;